import React, { useState, useContext } from 'react';
import styled from 'styled-components';
import PrimaryButton from './PrimaryButton';
import { FaBars } from 'react-icons/fa';
import { menuData } from '../data/menuData';
import MenuItems from '../Components/MenuItems';
import { motion } from 'framer-motion';
import { HashLink } from 'react-router-hash-link';
import { NavLink } from 'react-router-dom';
import DarkModeOutlinedIcon from '@mui/icons-material/DarkModeOutlined';
import { DarkModeContext } from '../context/darkModeContext';
import LightModeIcon from '@mui/icons-material/LightMode';
import Tooltip from '@mui/material/Tooltip';
import Mascot from './Animations/Mascot';

function Navbar() {
  const [navbar, setNavbar] = useState(false);

  const { dispatch, darkMode } = useContext(DarkModeContext);

  const fadeDown = {
    hidden: { opacity: 0, y: -100 },
    visible: { opacity: 1, y: 0 },
  };

  const variants = {
    open: { opacity: 1, y: 0 },
    closed: { opacity: 0, y: '-100%' },
  };

  const [isOpen, setIsOpen] = useState(false);

  const changeBackground = () => {
    if (window.scrollY >= 80) {
      setNavbar(true);
    } else {
      setNavbar(false);
    }
  };

  window.addEventListener('scroll', changeBackground);

  return (
    <NavbarStyled variants={fadeDown} initial="hidden" animate="visible">
      <motion.div
        className={navbar ? 'nav-content isactive' : 'nav-content'}
        initial={{ y: '-100%', opacity: 0 }}
        animate={{ y: 0, opacity: 1, scale: 1 }}
        transition={{ duration: 0.8, ease: 'easeOut' }}
        exit={{ y: '-100%', opacity: 0 }}
      >
        <HashLink to="/#">
          <div className="logo">
            <div className="mascot-img">
              <Mascot />
            </div>
            <div className="mascot-text">IMAFEEL</div>
          </div>
        </HashLink>

        <Bars onClick={() => setIsOpen((isOpen) => !isOpen)} />

        <div>
          {darkMode ? (
            <Tooltip title="Light Mode">
              <LightModeIcon className="icon-resp" onClick={() => dispatch({ type: 'TOGGLE' })} />
            </Tooltip>
          ) : (
            <Tooltip title="Dark Mode">
              <DarkModeOutlinedIcon className="icon-resp" onClick={() => dispatch({ type: 'TOGGLE' })} />
            </Tooltip>
          )}
        </div>

        <NavItems animate={isOpen ? 'open' : 'closed'} variants={variants}>
          <MenuItems />
        </NavItems>
        <NavMenu>
          {menuData.map((item, index) => {
            return (
              <motion.div
                key={index}
                whileHover={{
                  scale: 1.4,
                  transition: { duration: 0.2 },
                }}
                whileTap={{ scale: 0.8 }}
              >
                <HashLink to={item.link} className="nav-items">
                  {item.title}
                </HashLink>
              </motion.div>
            );
          })}
        </NavMenu>

        <NavBtn>
          <div className="item">
            <motion.div
              whileHover={{
                scale: 1.4,
                transition: { duration: 0.2 },
              }}
              whileTap={{ scale: 0.8 }}
            >
              {darkMode ? (
                <Tooltip title="Light Mode">
                  <LightModeIcon className="icon" onClick={() => dispatch({ type: 'TOGGLE' })} />
                </Tooltip>
              ) : (
                <Tooltip title="Dark Mode">
                  <DarkModeOutlinedIcon className="icon" onClick={() => dispatch({ type: 'TOGGLE' })} />
                </Tooltip>
              )}
            </motion.div>
          </div>

          <motion.div
            className="button-motion"
            whileHover={{
              scale: 1.2,
              transition: { duration: 0.2 },
            }}
            whileTap={{ scale: 0.8 }}
          >
            <NavLink to="/login">
              <PrimaryButton name={'Login'} />
            </NavLink>
          </motion.div>
        </NavBtn>
      </motion.div>
    </NavbarStyled>
  );
}
const NavbarStyled = styled(motion.nav)`
  width: 100%;

  display: flex;
  justify-content: center;

  .nav-content {
    width: 100%;
    display: flex;
    justify-content: space-between;
    padding: 0 18rem;
    min-height: 10vh;
    align-items: center;
    top: 0%;
    position: fixed;
    z-index: 100;
    background-color: transparent;
    transition: all 0.2s;
    @media screen and (max-width: 1566px) {
      padding: 0 10rem;
    }

    @media screen and (max-width: 1366px) {
      padding: 0 8rem;
    }
    @media screen and (max-width: 1186px) {
      padding: 0 6rem;
      display: contents;
    }
  }
  .nav-content.isactive {
    transition: all 0.2s ease-in-out;
    background-color: rgba(255, 255, 255, 0.9);
    color: var(--dark-primary);
  }
  .logo {
    z-index: 101;
    cursor: pointer;
    display: flex;
    text-align: center;
    justify-content: center;
    align-items: center;
    height: 100px;
    @media screen and (max-width: 1186px) {
      display: block;
      position: fixed;
      top: 0;
      left: 0;
      transform: translate(35%, 20%);
      font-size: 1.8rem;
    }
    .mascot-img {
      svg {
        height: 50px;
        width: 50px;
      }
    }
    .mascot-text {
      padding-left: 2px;
      @media screen and (max-width: 1186px) {
        display: none;
      }
    }
  }

  .nav-items {
    display: flex;
    justify-content: space-between;
    width: 0%;
    padding: 2rem;
  }

  .item {
    display: flex;
    align-items: center;
    margin: 25px;
    position: relative;

    .icon {
      cursor: pointer;
      font-size: 25px;
    }
  }

  .button-motion {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .icon-resp {
    display: none;
    z-index: 100;

    @media screen and (max-width: 1186px) {
      display: block;
      position: fixed;
      top: 0;
      right: 0;
      transform: translate(-100%, 250%);
      font-size: 1.8rem;
      cursor: pointer;
    }
  }
`;

const Bars = styled(FaBars)`
  color: #7199ff;
  display: none;
  z-index: 100;

  @media screen and (max-width: 1186px) {
    display: block;
    position: fixed;
    top: 0;
    right: 0;
    transform: translate(-100%, 75%);
    font-size: 1.8rem;
    cursor: pointer;
  }
`;
const NavItems = styled(motion.div)`
  display: none;
  @media screen and (max-width: 1186px) {
    z-index: 99;
    display: grid;
    position: fixed;
    height: 100%;
    width: 100%;
  }
`;

const NavMenu = styled.div`
  display: flex;
  align-items: center;
  margin-right: 0px;

  @media screen and (max-width: 1186px) {
    display: none;
  }
`;

const NavBtn = styled.div`
  display: flex;
  justify-content: center;
  @media screen and (max-width: 1186px) {
    display: none;
  }
`;

export default Navbar;
